module.exports = __webpack_public_path__ + "static/media/ic-season-winter.178b2a1a.svg";